// extracted by mini-css-extract-plugin
export default {"textSpecialShieldRoot":"textSpecialShieldRoot___EuguH","s":"s___lnUWe","m":"m___SQShX","l":"l___xxGSm","textSpecialShieldImg":"textSpecialShieldImg___PZpIi"};